const UTP_DATASTORE_PROD_URL = 'https://utp.autodesk.com/datastore/';
const UTP_DATASTORE_DEV_URL = 'https://dev.utp.autodesk.com/datastore/';

/**
 * Returns the UTP Data Store URL for the current Testing Hub deployment.
 * Production Testing Hub links to prod UTP; dev and local link to dev UTP.
 *
 * @returns {string}
 */
export function getUtpDatastoreUrl() {
  const host = (process.env.REACT_APP_HOST || '').toLowerCase();

  if (host.includes('testinghub.autodesk.com') && !host.includes('dev.')) {
    return UTP_DATASTORE_PROD_URL;
  }

  return UTP_DATASTORE_DEV_URL;
}
